import ViewController from "core/views/view.controller";

export default class CalendarItemCtrl extends ViewController {
    static $inject = ['$scope'];

    constructor() {
        super(...arguments);

        this.itemHeight = 0;
        this.itemTop = 0;
        this.itemLeft = 0;
        this.itemWidth = 0;

        // Bindings
        this.item = null;
        this.layout = null;
        this.zoom = 1;
    }

    $onChanges(changes) {
        if (changes.zoom && this.zoom == null) {
            this.zoom = 1;
        }

        this.update();
    }

    update() {
        let layoutColCount = this.layout.colCount * this.layout.colRatio;

        this.itemHeight = this.item.duration * this.zoom;
        this.itemTop = this.layout.rowOffset * this.zoom;
        this.itemLeft = this.layout.colIndex * (100 / layoutColCount);
        this.itemWidth = ((layoutColCount - this.layout.colIndex) * (100 / layoutColCount));
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/components/calendar/calendar-item.controller.js